<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px" top="3vh" @close="close">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="用户 ID" prop="code">
        <el-input v-model.trim="form.code" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="用户名称" prop="nickname">
        <el-input v-model.trim="form.nickname" autocomplete="off"></el-input>
      </el-form-item>
      <!-- 积分字段：增加加减按钮 -->
      <el-form-item label="用户余额" prop="balance">
        <div class="points-input-wrapper">
          <el-input v-model.trim="form.balance" autocomplete="off" class="points-input" :disabled="true"></el-input>
          <div class="points-buttons">
            <el-button type="success" size="small" icon="el-icon-plus" :disabled="!form.id"
              @click="showBalanceDialog('add')">
              加
            </el-button>
            <el-button type="danger" size="small" icon="el-icon-minus" :disabled="!form.id"
              @click="showBalanceDialog('subtract')">
              减
            </el-button>
          </div>
        </div>
        <div v-if="!form.id" class="points-tip">
          <i class="el-icon-info"></i>
          请先保存用户后再进行余额加减操作
        </div>
      </el-form-item>
      <el-form-item label="管理员" prop="code">
        <el-switch v-model="form.is_admin" :active-value="1" :inactive-value="0"></el-switch>
      </el-form-item>

      <!-- 积分字段：增加加减按钮 -->
      <el-form-item label="用户积分" prop="points">
        <div class="points-input-wrapper">
          <el-input v-model.trim="form.points" autocomplete="off" class="points-input" :disabled="true"></el-input>
          <div class="points-buttons">
            <el-button type="success" size="small" icon="el-icon-plus" :disabled="!form.id"
              @click="showPointsDialog('add')">
              加
            </el-button>
            <el-button type="danger" size="small" icon="el-icon-minus" :disabled="!form.id"
              @click="showPointsDialog('subtract')">
              减
            </el-button>
          </div>
        </div>
        <div v-if="!form.id" class="points-tip">
          <i class="el-icon-info"></i>
          请先保存用户后再进行积分加减操作
        </div>
      </el-form-item>




      <el-form-item label="上级用户" prop="nickname">
        <el-select ref="select" v-model="form.pid" filterable remote reserve-keyword placeholder="请输入关键词"
          :remote-method="remoteMethod">
          <el-option v-for="item in options" :key="item.id" :label="`${item.nickname} （${item.code
            ? item.code + '/' + item.ydm_code + '/' + item.ydr_code
            : '-'
            }）`" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="邮费模版" prop="nickname">
        <el-select v-model="form.postage_express_type" placeholder="请选择">
          <el-option v-for="item in postage_express_List" :key="item.value" :label="item.lable"
            :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="电话号码" prop="mobile">
        <el-input v-model.trim="form.mobile" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="add_time">
        <el-input v-model.trim="form.add_time" :disabled="true" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="用户头像" prop="pic">
        <el-upload class="avatar-uploader" :action="actionUrl" :show-file-list="false" :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>

    <!-- 积分加减弹窗 -->
    <el-dialog title="积分变动" :visible.sync="pointsDialogVisible" width="400px" append-to-body @close="closePointsDialog">
      <el-form :model="pointsForm" label-width="100px">
        <el-form-item label="当前积分">
          <span class="current-points">{{ formatPoints(form.points) }}</span>
        </el-form-item>
        <el-form-item :label="pointsType === 'add' ? '增加数量' : '减少数量'">
          <el-input v-model="pointsForm.amount" placeholder="请输入数量，支持小数点后两位" @input="handleAmountInput"
            @blur="handleAmountBlur">
            <template slot="append">
              <span class="amount-unit">积分</span>
            </template>
          </el-input>
          <div class="amount-tip">支持小数点后两位，如：1.5、0.01、100.25</div>
        </el-form-item>
        <el-form-item v-if="false" label="备注说明">
          <el-input v-model="pointsForm.remark" type="textarea" :rows="2" placeholder="请输入变动原因或备注（可选）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closePointsDialog">取 消</el-button>
        <el-button type="primary" :loading="pointsLoading" @click="confirmPointsChange">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 余额加减弹窗 -->
    <el-dialog title="余额变动" :visible.sync="balanceDialogVisible" width="400px" append-to-body
      @close="closeBalanceDialog">
      <el-form :model="balanceForm" label-width="100px">
        <el-form-item label="当前余额">
          <span class="current-points">{{ formatPoints(form.balance) }}</span>
        </el-form-item>
        <el-form-item :label="pointsType === 'add' ? '增加数量' : '减少数量'">
          <el-input v-model="balanceForm.balance" placeholder="请输入数量，仅支持整数" @input="handleAmountInput1"
            @blur="handleAmountBlur1">
            <template slot="append">
              <span class="amount-unit">余额</span>
            </template>
          </el-input>
          <div class="amount-tip">仅支持整数</div>
        </el-form-item>
        <el-form-item v-if="false" label="备注说明">
          <el-input v-model="balanceForm.remark" type="textarea" :rows="2" placeholder="请输入变动原因或备注（可选）"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeBalanceDialog">取 消</el-button>
        <el-button type="primary" :loading="pointsLoading" @click="confirmBalanceChange">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  memberUdate,
  memberDetail,
  memberListAll,
  MemberAddPoints,
  MemberUpdatePoints,
  add_balance,
  update_balance
} from '@/api/xgcApi'
import { getUploadUrl, baseURL_print } from '@/config'

export default {
  name: 'UserManagementEdit',
  components: {},
  props: {
    userList: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  data() {
    return {
      row: {},
      form: {
        is_admin: 0,
        postage_express_type: null,
        pid: null,
        points: 0,
        balance: 0,
      },
      dialogFormVisible: false,
      postage_express_List: [
        {
          lable: '圆通',
          value: 1,
        },
        {
          lable: '京东',
          value: 2,
        },
        {
          lable: '顺丰海运',
          value: 3,
        },
        {
          lable: '特殊模版',
          value: 4,
        },
      ],
      queryForm: {
        page: 1,
        limit: 20,
      },
      rules: {
        username: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入用户名',
          },
        ],
        password: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入密码',
          },
        ],
        email: [
          {
            required: true,
            trigger: 'blur',
            message: '请输入邮箱',
          },
        ],
        permissions: [
          {
            required: true,
            trigger: 'blur',
            message: '请选择权限',
          },
        ],
      },
      title: '',
      imageUrl: '',
      actionUrl: baseURL_print + 'index/index/file',
      options: [],
      // 积分弹窗相关
      pointsDialogVisible: false,
      pointsType: 'add', // 'add' 或 'subtract'
      pointsForm: {
        amount: '1',
        remark: '',
      },
      balanceForm: {
        balance: '1',
        remark: '',
      },
      pointsLoading: false,
    }
  },

  mounted() { },
  methods: {
    // 格式化积分显示（保留两位小数）
    formatPoints(value) {
      if (value === null || value === undefined || value === '') return '0.00'
      const num = parseFloat(value)
      if (isNaN(num)) return '0.00'
      return num.toFixed(2)
    },

    getUserInfo() {
      var data = {
        page: 1,
        limit: 100,
      }
      memberListAll(data).then(({ data }) => {
        this.options = data
        memberDetail({ id: this.row.id }).then((res) => {
          this.form = res.data
          // 确保积分显示保留两位小数
          if (this.form.points) {
            this.form.points = parseFloat(this.form.points).toFixed(2)
          }
          this.imageUrl = res.data.pic
          this.dialogFormVisible = true
          if (res.data.p_user) {
            const hasId = this.options.some(
              (item) => item.id == res.data.p_user.id
            )
            if (!hasId) {
              this.options.push(res.data.p_user)
            }
          }
        })
      })
    },

    remoteMethod(e) {
      this.page = 1
      this.limit = 20
      var data = {
        nickname: e,
        page: 1,
        limit: 100,
      }
      memberListAll(data).then(({ data }) => {
        this.options = data
      })
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.form.pic = getUploadUrl + res
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },

    async showEdit(row) {
      this.title = '用户信息编辑'
      this.row = row
      this.getUserInfo()
    },

    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
      // 关闭积分弹窗（如果打开着）
      this.pointsDialogVisible = false
    },

    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          // 提交前确保积分是数字类型
          const submitForm = {
            ...this.form,
            points: parseFloat(this.form.points) || 0,
          }
          const { msg } = await memberUdate(submitForm)
          this.$baseMessage(msg, 'success')
          this.$emit('fetch-data')
          this.close()
        } else {
          return false
        }
      })
    },

    // 处理积分数量输入（实时限制小数点后两位）
    handleAmountInput(value) {
      // 允许清空
      if (value === '' || value === null || value === undefined) {
        this.pointsForm.amount = ''
        return
      }

      // 转换为字符串处理
      let str = String(value)

      // 移除开头的多个0（保留一个0）
      if (str.length > 1 && str.startsWith('0') && !str.startsWith('0.')) {
        str = str.replace(/^0+/, '')
        if (str === '' || str === '.') str = '0'
      }

      // 限制只能输入数字和小数点
      let match = str.match(/^\d*\.?\d{0,2}/)
      if (match) {
        let result = match[0]
        // 避免单独的小数点
        if (result === '.') result = '0.'
        this.pointsForm.amount = result
      }
    },

    // 失去焦点时格式化数量
    handleAmountBlur() {
      let value = this.pointsForm.amount
      if (value === '' || value === null || value === undefined) {
        this.pointsForm.amount = '1'
        return
      }

      let num = parseFloat(value)
      if (isNaN(num) || num <= 0) {
        this.pointsForm.amount = '1'
        this.$message.warning('数量必须大于0，已自动设置为1')
      } else {
        // 保留两位小数显示
        this.pointsForm.amount = num.toFixed(2)
      }
    },

    // 处理积分数量输入（实时限制小数点后两位）
    handleAmountInput1(value) {
      // 允许清空
      if (value === '' || value === null || value === undefined) {
        this.balanceForm.balance = ''
        return
      }

      // 转换为字符串处理
      let str = String(value)

      // 移除开头的多个0（保留一个0）
      if (str.length > 1 && str.startsWith('0') && !str.startsWith('0.')) {
        str = str.replace(/^0+/, '')
        if (str === '' || str === '.') str = '0'
      }

      this.balanceForm.balance = str.replace(/\D/g, '')
    },
    // 失去焦点时格式化数量
    handleAmountBlur1() {
      let value = this.balanceForm.balance
      if (value === '' || value === null || value === undefined) {
        this.balanceForm.balance = '1'
        return
      }

      let num = parseInt(value)
      if (isNaN(num) || num <= 0) {
        this.balanceForm.balance = '1'
        this.$message.warning('数量必须大于0，已自动设置为1')
      } else {
        // 保留两位小数显示
        this.balanceForm.balance = num
      }
    },
    // 显示积分加减弹窗
    showPointsDialog(type) {
      if (!this.form.id) {
        this.$message.warning('请先保存用户信息后再进行积分操作')
        return
      }
      this.pointsType = type
      this.pointsForm = {
        amount: '1',
        remark: '',
      }
      // 如果是减分，校验最大数量不能超过当前积分
      if (type === 'subtract') {
        const currentPoints = parseFloat(this.form.points) || 0
        if (currentPoints <= 0) {
          this.$message.warning('当前积分为0，无法再减少')
          return
        }
      }
      this.pointsDialogVisible = true
    },


    showBalanceDialog(type) {
      if (!this.form.id) {
        this.$message.warning('请先保存用户信息后再进行积分操作')
        return
      }
      this.pointsType = type
      this.balanceForm = {
        balance: '1',
        remark: '',
      }
      // 如果是减分，校验最大数量不能超过当前积分
      if (type === 'subtract') {
        const currentPoints = parseFloat(this.form.balance) || 0
        if (currentPoints <= 0) {
          this.$message.warning('当前余额为0，无法再减少')
          return
        }
      }
      this.balanceDialogVisible = true
    },

    // 关闭积分弹窗
    closePointsDialog() {
      this.pointsDialogVisible = false
      this.pointsForm = {
        amount: '1',
        remark: '',
      }
    },

    // 关闭余额弹窗
    closeBalanceDialog() {
      this.balanceDialogVisible = false
      this.balanceForm = {
        amount: '1',
        remark: '',
      }
    },

    // 确认积分变动
    async confirmPointsChange() {
      // 获取并校验数量
      let amount = this.pointsForm.amount
      if (amount === '' || amount === null || amount === undefined) {
        this.$message.warning('请输入变动数量')
        return
      }

      // 转换为数字
      let numAmount = parseFloat(amount)
      if (isNaN(numAmount)) {
        this.$message.warning('请输入有效的数字')
        return
      }

      // 校验数量必须大于0
      if (numAmount <= 0) {
        this.$message.warning('变动数量必须大于0')
        return
      }

      // 校验小数位数（最多两位）
      const amountStr = String(numAmount)
      const decimalMatch = amountStr.match(/\.(\d+)$/)
      if (decimalMatch && decimalMatch[1].length > 2) {
        this.$message.warning('数量最多支持小数点后两位')
        return
      }

      // 保留两位小数
      numAmount = parseFloat(numAmount.toFixed(2))

      const currentPoints = parseFloat(this.form.points) || 0
      let newPoints = currentPoints

      if (this.pointsType === 'add') {
        newPoints = parseFloat((currentPoints + numAmount).toFixed(2))
      } else {
        if (numAmount > currentPoints) {
          this.$message.warning(
            `减少数量不能超过当前积分 ${currentPoints.toFixed(2)}`
          )
          return
        }
        newPoints = parseFloat((currentPoints - numAmount).toFixed(2))
      }

      this.pointsLoading = true
      try {
        // 调用更新接口
        const updateData = {
          id: this.form.id,
          points: numAmount, // 传递变动数量
        }

        let res
        if (this.pointsType === 'add') {
          res = await MemberAddPoints(updateData)
        } else {
          res = await MemberUpdatePoints(updateData)
        }

        const { msg } = res

        // 更新本地显示（保留两位小数）
        this.form.points = newPoints.toFixed(2)

        const actionText = this.pointsType === 'add' ? '增加' : '减少'
        const remarkText = this.pointsForm.remark
          ? `，备注：${this.pointsForm.remark}`
          : ''
        this.$message.success(
          `积分${actionText}成功！${actionText}数量：${numAmount.toFixed(
            2
          )}${remarkText}`
        )

        // 刷新父组件数据
        this.$emit('fetch-data')
        this.closePointsDialog()
      } catch (error) {
        this.$message.error(
          '积分变动失败：' + (error.msg || error.message || '未知错误')
        )
      } finally {
        this.pointsLoading = false
      }
    },
    async confirmBalanceChange() {
      // 获取并校验数量
      let amount = this.balanceForm.balance
      if (amount === '' || amount === null || amount === undefined) {
        this.$message.warning('请输入变动数量')
        return
      }

      // 转换为数字
      let numAmount = parseFloat(amount)
      if (isNaN(numAmount)) {
        this.$message.warning('请输入有效的数字')
        return
      }

      // 校验数量必须大于0
      if (numAmount <= 0) {
        this.$message.warning('变动数量必须大于0')
        return
      }

      // 校验必须为整数
      if (!Number.isInteger(numAmount)) {
        this.$message.warning('数量必须为整数')
        return
      }

      const currentPoints = parseFloat(this.form.balance) || 0
      let newPoints = currentPoints

      if (this.pointsType === 'add') {
        newPoints = parseInt(currentPoints + numAmount)
      } else {
        if (numAmount > currentPoints) {
          this.$message.warning(
            `减少数量不能超过当前余额 ${currentPoints}`
          )
          return
        }
        newPoints = parseInt(currentPoints - numAmount)
      }

      this.pointsLoading = true
      try {
        // 调用更新接口
        const updateData = {
          id: this.form.id,
          balance: numAmount, // 传递变动数量
        }

        let res
        if (this.pointsType === 'add') {
          res = await add_balance(updateData)
        } else {
          res = await update_balance(updateData)
        }

        const { msg } = res

        // 更新本地显示（保留两位小数）
        this.form.balance = newPoints

        const actionText = this.pointsType === 'add' ? '增加' : '减少'
        const remarkText = this.balanceForm.remark
          ? `，备注：${this.balanceForm.remark}`
          : ''
        this.$message.success(
          `余额${actionText}成功！${actionText}数量：${numAmount}${remarkText}`
        )

        // 刷新父组件数据
        this.$emit('fetch-data')
        this.closeBalanceDialog()
      } catch (error) {
        this.$message.error(
          '余额变动失败：' + (error.msg || error.message || '未知错误')
        )
      } finally {
        this.pointsLoading = false
      }
    }
  },
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* 积分输入框样式 */
.points-input-wrapper {
  display: flex;
  gap: 10px;
  align-items: center;
}

.points-input {
  flex: 1;
}

.points-buttons {
  display: flex;
  gap: 8px;
}

.points-tip {
  font-size: 12px;
  color: #e6a23c;
  margin-top: 5px;
}

.points-tip i {
  margin-right: 4px;
}

.current-points {
  font-size: 18px;
  font-weight: bold;
  color: #409eff;
}

.amount-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.amount-unit {
  font-size: 12px;
}

/* 隐藏 number 输入框的上下箭头（可选） */
.points-input-wrapper input[type='number']::-webkit-inner-spin-button,
.points-input-wrapper input[type='number']::-webkit-outer-spin-button {
  opacity: 0.5;
}
</style>
